import React from "react";
import { HashRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import ContextProvider from "./components/ContextProvider";
import Snowfall from "react-snowfall";

const currentMonth = new Date().getMonth(); // 0 = January, 11 = December
const showSnowfall = currentMonth === 0 || currentMonth === 11;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <React.Suspense fallback="">
      <HashRouter>
        <ContextProvider>
          {showSnowfall && (
            <Snowfall
              color="#87CEEB"
              style={{
                position: "fixed",
                zIndex: 999999999,
                pointerEvents: "none",
              }}
            />
          )}
          <App />
        </ContextProvider>
      </HashRouter>
    </React.Suspense>
  </React.StrictMode>
);

reportWebVitals();
